import { render } from "./PantrySelectCategoryItem.vue?vue&type=template&id=357d9422&scoped=true&ts=true"
import script from "./PantrySelectCategoryItem.vue?vue&type=script&lang=ts"
export * from "./PantrySelectCategoryItem.vue?vue&type=script&lang=ts"

import "./PantrySelectCategoryItem.vue?vue&type=style&index=0&id=357d9422&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-357d9422"]])

export default __exports__